import { createModel } from "~~/package/utils/ModelUtil";
import Model from "~~/package/mapper/Model";
import { MemberMenuAccessRole } from "~~/package/mapper/organization/model/OrganizationMemeberTypes";
import { UserV2Type } from "~~/package/mapper/user/model/UserType";

export class OrganizationInviteMemberModel extends Model {
  constructor(
      public uid = crypto.randomUUID(),
      public email: string = "",
      public accessRoles: MemberMenuAccessRole[] = [
          MemberMenuAccessRole.ROLE_SKILL_MONITOR, MemberMenuAccessRole.ROLE_SKILL_CERTIFY
      ],
      public organizationRole: UserV2Type | null = null,
      public emailErrors: string[] = [],
      public menuError: boolean = false,
      public roleError: boolean = false
  ) {
    super();
  }

  public static create(model: Partial<OrganizationInviteMemberModel>): OrganizationInviteMemberModel {
    return createModel<OrganizationInviteMemberModel>(OrganizationInviteMemberModel, {
      ...model
    });
  }
}
